<template>
  <div>
    <div class="row justify-content-center mb-2">
      <button class="btn btn-add" id="v-step-0" @click="startTour">
        Iniciar Tour de Serviços Adicionais
      </button>
    </div>
    <v-tour name="myTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step1, index) of tour.steps"
            :key="index"
            :step="step1"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template>
              <div slot="actions">
                <button
                  v-if="tour.currentStep != 0"
                  @click="tour.previousStep"
                  class="btn-step-back"
                >
                  Anterior
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  class="btn-step-back"
                >
                  Pular tour
                </button>
                <button
                  @click="
                    nextTour(
                      tour.currentStep,
                      tour.steps[index + 1],
                      tour.steps[index]
                    )
                  "
                  v-if="tour.currentStep != 14"
                  class="btn-step"
                >
                  Próximo
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  v-else
                  class="btn-step"
                >
                  Finalizar
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <div class="card">
      <div class="card-header">
        <div class="card-title">Serviços Adicionais Solicitados - Hoje</div>
      </div>
      <div class="card-body mt-4">
        <div class="row mb-4">
          <div class="col-md-2" align="left">
            <button
              class="btn btn-add"
              type="button"
              @click="collapseToggle"
              id="v-step-2"
            >
              <i class="fas fa-filter"></i> Filtros
            </button>
          </div>
          <div class="col-md-2">
            <button
              class="btn btn-add"
              type="button"
              id="v-step-14"
              @click="getEntity"
            >
              <i class="fas fa-sync-alt"></i> Atualizar
            </button>
          </div>
        </div>

        <div class="row mb-3" v-if="collapse == 1">
          <div class="col-md-6">
            <label id="v-step-3">Filtrar Sala</label>
            <v-select
              :options="rooms"
              label="title"
              :reduce="(rooms) => rooms.id"
              multiple
              class="style-chooser"
              v-model="filters.room_id"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-6">
            <label id="v-step-4">Filtrar Serviço</label>
            <v-select
              :options="additionals"
              label="title"
              :reduce="(additionals) => additionals.id"
              multiple
              class="style-chooser"
              v-model="filters.additional_id"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-4 mt-2">
            <label id="v-step-5">Status</label>
            <v-select
              :options="status"
              label="text"
              :reduce="(status) => status.id"
              multiple
              class="style-chooser"
              v-model="filters.status"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>

          <div class="col-md-12 mt-4 mb-3" align="center">
            <button class="btn btn-add" id="v-step-8" @click="getEntity()">
              Pesquisar
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table" style="font-size: 14px">
              <thead>
                <tr>
                  <th scope="col" id="v-step-9">#</th>
                  <th scope="col">Serviço</th>
                  <th scope="col">Solicitante</th>
                  <th scope="col">Data</th>
                  <th scope="col">Sala</th>
                  <th scope="col">E-mail Responsável</th>
                  <th scope="col" id="v-step-1">Status</th>
                  <th scope="col" id="v-step-10">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="service in services" :key="service.id">
                  <td>{{ service.id }}</td>
                  <td>{{ service.additional.title }}</td>
                  <td>{{ service.reserve.user.name }}</td>
                  <td>{{ service.reserve.date_start }}</td>
                  <td>{{ service.reserve.room.title }}</td>
                  <td>
                    {{
                      service.additional.email
                        ? service.additional.email
                        : "Não enviado"
                    }}
                  </td>
                  <td>
                    <h6>
                      <span
                        v-if="service.status == 0"
                        class="badge badge-warning"
                        >Aguardando</span
                      >
                      <span
                        v-if="service.status == 1"
                        class="badge badge-primary"
                        >Em andamento</span
                      >
                      <span
                        v-if="service.status == 2"
                        class="badge badge-success"
                        >Finalizado</span
                      >
                    </h6>
                  </td>
                  <td>
                    <b-button
                      variant="btn btn-add"
                      v-b-modal.modalManage
                      @click="dataModal = service"
                    >
                      <i class="fas fa-eye"></i>
                    </b-button>
                  </td>
                </tr>
                <tr v-if="services.length == 0">
                  <td colspan="8" align="center">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <pagination
              :records="total"
              :options="options"
              :per-page="10"
              @paginate="getEntity"
            ></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <b-modal
      id="modalManage"
      hide-footer="true"
      v-if="dataModal != null"
      size="lg"
    >
      <div class="modal-content">
        <div class="modal-body">
          <div class="row justify-content-center mt-3">
            <div class="col-md-12 centered bold" style="font-size: 16px">
              Serviço Solicitado
            </div>
            <div class="col-md-12 centered mt-1" style="font-size: 20px">
              {{ dataModal.additional.title }}
            </div>
            <div class="col-md-12 centered mt-1" style="font-size: 16px">
              Descrição: {{ dataModal.additional.description }}
            </div>
            <div class="col-md-11 mt-4 bold">
              <label for="title">Título da Reunião</label>
              <input
                type="text"
                disabled
                v-model="dataModal.reserve.title"
                name="title"
                class="form-control"
                id
              />
            </div>
            <div class="col-md-4 mt-3">
              <div class="form-group bold">
                <label for="inputPlace">Data Início</label>
                <input
                  type="text"
                  disabled
                  class="form-control"
                  v-model="dataModal.reserve.date_start"
                />
              </div>
            </div>
            <div class="col-md-4 mt-3">
              <div class="form-group bold">
                <label for="inputPlace">Data Final</label>
                <input
                  type="text"
                  disabled
                  class="form-control"
                  v-model="dataModal.reserve.date_end"
                />
              </div>
            </div>
            <div class="col-md-12 mt-3">
              <div class="container-fluid">
                <div class="row justify-content-center">
                  <!-- Room Card -->
                  <div class="col-md-6">
                    <div class="card">
                      <img
                        class="card-img-top"
                        :src="dataModal.reserve.room.photo"
                        alt
                      />

                      <div class="card-body">
                        <div class="room-name">
                          {{ dataModal.reserve.room.title }}
                          <span class="room-distance">{{
                            dataModal.reserve.room.tag
                          }}</span>
                        </div>
                        <div class="room-info">
                          <label>Adicionais da Sala</label>
                          <div class="room-place">
                            <span
                              class="badge badge-secondary lg-badge"
                              v-for="detail in dataModal.reserve.room.details"
                              :key="detail.id"
                              style="padding: 3px"
                              >{{ detail.detail.title }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row text-center mb-3 mt-3">
            <div class="col">
              <b-button
                variant="btn btn-warning bold"
                id="v-step-11"
                @click="changeStatus(0)"
              >
                Aguardando
              </b-button>
            </div>
            <div class="col">
              <b-button
                variant="btn btn-primary bold"
                id="v-step-12"
                @click="changeStatus(1)"
              >
                Em andamento
              </b-button>
            </div>
            <div class="col">
              <b-button
                variant="btn btn-success bold"
                id="v-step-13"
                @click="changeStatus(2)"
              >
                Finalizar
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";
export default {
  data: function () {
    return {
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Tela de Serviços Adicionais Solicitados!",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content:
            "Por padrão deixamos um filtro automático com o Status: Aguardando e Em Andamento. Então se caso já existir algum Serviço Solicitado com esses status, ele iŕa aparecer sem necessidade de filtro. ",
        },
        {
          target: "#v-step-14",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content:
            "Aqui temos um botão para Atualizar a página e limpar os filtros.",
        },
        {
          target: "#v-step-2",
          params: {
            enableScrolling: false,
          },
          content:
            "Aqui temos alguns Filtros para podermos buscar um Serviço desejado.",
        },
        {
          target: "#v-step-3",
          params: {
            enableScrolling: false,
          },
          content: "Filtramos pela Sala de Reunião",
        },
        {
          target: "#v-step-4",
          params: {
            enableScrolling: false,
          },
          content: "Filtramos pelo Serviço Adicional",
        },
        {
          target: "#v-step-5",
          params: {
            enableScrolling: false,
          },
          content: "Pelo Status do Serviço Adicional",
        },
        {
          target: "#v-step-8",
          params: {
            enableScrolling: false,
          },
          content:
            "E clique em Pesquisar, e abaixo irá exibir os serviços com base nos filtros.",
        },
        {
          target: "#v-step-9",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content: "Aqui temos os resultados dos filtros",
        },
        {
          target: "#v-step-10",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content:
            "Clique em Ação para você poderá alterar o status deste Serviço e podermos seguir com o tour.",
        },
        {
          target: "#v-step-11",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content:
            "Clicando aqui você muda o status para Aguardando, por padrão o status do serviço já vem como Aguardando, então só será necessário a mudança de status se ele estiver Em Andamente ou Finalizado.",
        },
        {
          target: "#v-step-12",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content:
            "Clicando aqui você muda o status de Aguardando para Em Andamento.",
        },
        {
          target: "#v-step-13",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content:
            "Clicando aqui você muda o status de Aguardando ou Em Andamento para Finalizado.",
        },
      ],
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      collapse: 0,
      services: [],
      additionals: [],
      rooms: [],
      filters: {
        status: [0, 1],
        date_start: null,
        date_end: null,
      },
      dataModal: null,
      refreshInterval: null,
      status: [
        {
          id: 0,
          text: "Aguardando",
        },
        {
          id: 1,
          text: "Em andamento",
        },
        {
          id: 2,
          text: "Finalizado",
        },
      ],
    };
  },
  components: { vSelect, Pagination },
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => {});
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 2) {
        this.collapseToggle();
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    getEntity(page) {
      const self = this;
      self.page = page;
      
      // Define a data de hoje para filtrar apenas os dados do dia
      const today = new Date().toISOString().split('T')[0];
      const filtersWithToday = Object.assign({}, self.filters, {
        date_start: today,
        date_end: today
      });
      
      const api =
        self.$store.state.api + "services_additionals/manage?page=" + self.page;

      self.$http
        .post(api, filtersWithToday)
        .then((response) => {
          self.services = response.data.data;
          self.total = response.data.total;
          self.$store.commit("updateNotifications");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    collapseToggle() {
      if (this.collapse == 1) {
        this.collapse = 0;
      } else {
        this.collapse = 1;
      }
    },
    changeStatus(status) {
      const self = this;
      const api = self.$store.state.api + "services_additionals/change-status";

      self.$http
        .post(api, { additional_id: self.dataModal.id, status: status })
        .then(() => {
          self.getEntity();
          self.$message(
            "Sucesso",
            "Adicional atualizado com sucesso",
            "success"
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRooms: function () {
      const self = this;
      const api = self.$store.state.api + "rooms?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.rooms = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getAdditionals: function () {
      const self = this;
      const api =
        self.$store.state.api + "services_additionals?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.additionals = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    startAutoRefresh() {
      const self = this;
      // Limpa o intervalo anterior se existir
      if (self.refreshInterval) {
        clearInterval(self.refreshInterval);
      }
      
      // Define um novo intervalo para atualizar a cada 5 segundos
      self.refreshInterval = setInterval(() => {
        self.getEntity(self.page);
      }, 5000);
    },
    stopAutoRefresh() {
      const self = this;
      if (self.refreshInterval) {
        clearInterval(self.refreshInterval);
        self.refreshInterval = null;
      }
    },
  },
  mounted() {
    this.getEntity();
    this.getRooms();
    this.getAdditionals();
    this.startAutoRefresh();
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ServicesAdditional/Manage.vue